import {Box, FormControlLabel, Switch} from '@mui/material'
import TextField from '@mui/material/TextField'
import {DatePicker, LocalizationProvider} from '@mui/x-date-pickers'
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns'
import moment from 'moment'
import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

type NotifyAtFieldProps = {
  checked: boolean
  date?: Date
  onToggle: (enabled: boolean) => void
  onDateChange: (date?: Date) => void
}

export const NotifyAtField: React.FC<NotifyAtFieldProps> = ({
  checked,
  date,
  onToggle,
  onDateChange
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const [dateValue, setDateValue] = useState<Date | null>(date ?? null)

  useEffect(() => {
    setDateValue(date ?? null)
  }, [date])

  return (
    <Box my={2} data-test-id="notify-at-section">
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            onChange={(_, value) => {
              onToggle(value)
              if (!value) {
                setDateValue(null)
              }
            }}
            data-test-id="notify-at-toggle"
          />
        }
        label={t('actionDialog.scheduleEmailNotification')}
      />
      {checked && (
        <Box mt={1}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label={t('actionDialog.notifyAt')}
              value={dateValue}
              inputFormat={t('dateTime.dateFormat', 'MM/dd/yyyy')}
              minDate={new Date()}
              onChange={(val) => {
                setDateValue(val)
              }}
              onAccept={(value) => {
                onDateChange(value ?? undefined)
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="filled"
                  data-test-id="notify-at-date"
                  onBlur={() => {
                    if (dateValue && moment(dateValue).isValid()) {
                      onDateChange(dateValue)
                    } else {
                      setDateValue(date ?? null)
                    }
                  }}
                />
              )}
            />
          </LocalizationProvider>
        </Box>
      )}
    </Box>
  )
}
